import { useEffect } from "react";
import { useCart } from "../context/CartContext";

function CartPage() {
  const { cart, removeFromCart, totalItems } = useCart();

  useEffect(() => {
    console.log("Cart contents:", cart);
  }, [cart]);

  // ✅ Calculate subtotal
  const subtotal = cart.reduce(
    (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1),
    0
  );

  const vatRate = 0.15; // 15%
  const vat = subtotal * vatRate;
  const grandTotal = subtotal + vat;

  return (
    <div className="container mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">🛒 Your Cart</h1>

      {cart.length === 0 ? (
        <p className="text-gray-500 text-lg">No items in cart</p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Cart Items */}
          <div className="lg:col-span-2 space-y-4">
            {cart.map((item) => (
              <div
                key={item.productId}
                className="flex items-start bg-white rounded-2xl shadow-md p-4 hover:shadow-lg transition"
              >
                {/* Image (placeholder if not available) */}
                <img
                  src={item.image || "https://via.placeholder.com/100x100"}
                  alt={item.name}
                  className="w-24 h-24 object-cover rounded-xl border"
                />

                {/* Details */}
                <div className="ml-4 flex-1">
                  <h2 className="text-lg font-semibold text-gray-800">
                    {item.name}
                  </h2>
                  <p className="text-sm text-gray-500">
                    Company: {item.companyId}
                  </p>

                  {/* Extra details if available */}
                  {item.notes && (
                    <p className="text-sm text-gray-600 mt-1">
                      Notes: {item.notes}
                    </p>
                  )}
                  {item.date && (
                    <p className="text-sm text-gray-600">
                      Date: {item.date} {item.time && `at ${item.time}`}
                    </p>
                  )}
                  {item["Number of Persons"] && (
                    <p className="text-sm text-gray-600">
                      Persons: {item["Number of Persons"]}
                    </p>
                  )}
                  {item.rentalDuration && (
                    <p className="text-sm text-gray-600">
                      Duration: {item.rentalDuration}
                    </p>
                  )}

                  {/* Price */}
                  <div className="mt-2 flex justify-between items-center">
                    <p className="font-semibold text-gray-900">
                      ${(Number(item.price) * Number(item.quantity || 1)).toFixed(2)}
                    </p>
                    <p className="text-sm text-gray-500">
                      x{item.quantity || 1}
                    </p>
                  </div>
                </div>

                {/* Remove Button */}
                <button
                  onClick={() => removeFromCart(item.productId)}
                  className="ml-4 text-red-500 hover:text-red-700 transition"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>

          {/* Order Summary */}
          <div className="bg-white rounded-2xl shadow-md p-6 h-fit">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">
              Order Summary
            </h2>
            <div className="space-y-2 text-gray-700">
              <div className="flex justify-between">
                <span>Subtotal ({totalItems} items)</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>VAT (15%)</span>
                <span>${vat.toFixed(2)}</span>
              </div>
              <div className="flex justify-between font-bold text-lg text-gray-900 border-t pt-3">
                <span>Total</span>
                <span>${grandTotal.toFixed(2)}</span>
              </div>
            </div>

            {/* Payment Methods */}
            <div className="mt-6 space-y-3">
              <h3 className="text-md font-semibold text-gray-800">
                Choose Payment Method
              </h3>

              <button className="w-full bg-black text-white py-3 rounded-xl flex justify-center items-center space-x-2 hover:opacity-90 transition">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  alt="Google Pay"
                  className="w-5 h-5"
                />
                <span>Pay with Google Pay</span>
              </button>

              <button className="w-full bg-black text-white py-3 rounded-xl flex justify-center items-center space-x-2 hover:opacity-90 transition">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                  alt="Apple Pay"
                  className="w-5 h-5"
                />
                <span>Pay with Apple Pay</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartPage;